export const tipos = [
  {Id:'CA', Nombre: "CASA"},
  {Id:'CD', Nombre: "CONDOMINIO"},
  {Id:'DE', Nombre: "DEPARTAMENTO"},
  {Id:'OT', Nombre: "OTRO"},
  {Id:'TE', Nombre: "TERRENO"},
]
